export const semanticTokens = {
	colors: {
		text: {
			default: {
				default: 'gray.900',
			},
			soft: {
				default: 'gray.700',
			},
			softer: {
				default: 'gray.600',
			},
			softest: {
				default: 'gray.500',
			},
			onColor: {
				default: 'white',
			},
			interactive: {
				default: 'blue.500',
			},
			hashtag: {
				default: 'purple.500',
			},
			disabled: {
				default: '#a6acb5ff',
			},
		},
		bg: {
			canvas: {
				default: 'gray.25',
			},
			surface: {
				default: 'white',
			},
			soft: {
				default: 'gray.100',
			},
			subtle: {
				default: 'gray.50',
			},
			topNav: {
				default: 'whiteAlpha.1000',
			},
			overlayBackdrop: {
				default: 'blackAlpha.500',
			},
		},
		primary: {
			fg: {
				default: 'blue.500',
			},
			fgStrong: {
				default: 'blue.600',
			},
			fgStronger: {
				default: 'blue.700',
			},
			fgStrongest: {
				default: 'blue.800',
			},
			bgAlpha: {
				default: 'blueAlpha.100',
			},
			bgAlphaHover: {
				default: 'blueAlpha.200',
			},
			bgAlphaActive: {
				default: 'blueAlpha.300',
			},
			bg: {
				default: 'blue.500',
			},
			bgHover: {
				default: 'blue.600',
			},
			bgActive: {
				default: 'blue.700',
			},
		},
		secondary: {
			fg: {
				default: 'gray.800',
			},
			fgActive: {
				default: 'gray.900',
			},
			bg: {
				default: 'gray.900',
			},
			bgHover: {
				default: 'gray.700',
			},
			bgActive: {
				default: 'gray.600',
			},
			bgAlpha: {
				default: 'grayAlpha.100',
			},
			bgAlphaHover: {
				default: 'grayAlpha.200',
			},
			bgAlphaActive: {
				default: 'grayAlpha.300',
			},
		},
		points: {
			fg: {
				default: 'green.600',
			},
			fgHover: {
				default: 'green.700',
			},
			fgOnSurface: {
				default: 'green.500',
			},
			bgAlpha: {
				default: 'greenAlpha.100',
			},
			bgAlphaHover: {
				default: 'greenAlpha.200',
			},
			bgAlphaActive: {
				default: 'greenAlpha.300',
			},
		},
		hashtag: {
			fgOnSurface: {
				default: 'purple.500',
			},
			fg: {
				default: 'purple.600',
			},
			fgHover: {
				default: 'purple.700',
			},
			bgAlpha: {
				default: 'purpleAlpha.100',
			},
			bgAlphaHover: {
				default: 'purpleAlpha.200',
			},
			bgAlphaActive: {
				default: 'purpleAlpha.300',
			},
		},
		border: {
			default: {
				default: 'grayAlpha.300',
			},
			soft: {
				default: 'grayAlpha.100',
			},
			focus: {
				default: 'blue.500',
			},
			input: {
				default: 'gray.500',
			},
		},
		success: {
			text: {
				default: 'green.600',
			},
			bg: {
				default: 'green.50',
			},
			closeBg: {
				default: 'greenAlpha.100',
			},
			icon: {
				default: 'green.500',
			},
			datavizMid: {
				default: 'green.400',
			},
		},
		error: {
			text: {
				default: 'red.600',
			},
			bg: {
				default: 'red.50',
			},
			closeBg: {
				default: 'redAlpha.100',
			},
			icon: {
				default: 'red.600',
			},
			inputBorder: {
				default: 'red.500',
			},
			inputBg: {
				default: 'red.25',
			},
			datavizMid: {
				default: 'red.400',
			},
		},
		warning: {
			text: {
				default: 'yellow.700',
			},
			bg: {
				default: 'yellow.50',
			},
			closeBg: {
				default: 'yellowAlpha.100',
			},
			icon: {
				default: 'yellow.500',
			},
			datavizMid: {
				default: 'yellow.400',
			},
		},
		info: {
			text: {
				default: 'gray.700',
			},
			bg: {
				default: 'gray.50',
			},
			closeBg: {
				default: 'grayAlpha.100',
			},
			icon: {
				default: 'gray.500',
			},
			datavizMid: {
				default: 'gray.400',
			},
		},
	},
	space: {
		paragraph: {
			1: '0.5rem',
			50: '0.625rem',
			100: '0.75rem',
			150: '0.875rem',
			200: '1rem',
			300: '1.125rem',
			400: '1.375rem',
			500: '1.5rem',
			600: '1.75rem',
			700: '2rem',
			800: '2.25rem',
			900: '2.5rem',
			1000: '3rem',
			1100: '3.5rem',
			1200: '3.75rem',
		},
	},
};
